import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ServiceSix from "../elements/service/ServiceSix";
import ServiceEight from "../elements/service/ServiceEight";


const DigitalMarketing = () => {
    return (
        <>
            <SEO title="Bulk SMS"/>
            <Layout>
                <Separator/>
                {/* Start Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="content">
                                    <h3 className="title">USSD Application Development & Integration</h3>
                                    <h4 className="title">Make your services available on all mobile devices, including smartphones and non-smartphones ("Kabambe").</h4>
                                    <p className="mb--10">GSM telephones employ the Unstructured Supplementary Service Data (USSD) text-driven protocol, which
                                        enables users to communicate with an application via a network operator.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <img src="../images/ussd/ussd3.png" alt="split Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="What Mixon will provide"
                                    description="In addition to hosting the application, writing the logic, designing the database structure,
                                    or just integrating to an existing system or application, we assist businesses in developing USSD apps.You can register your shortcode with the help of Ziprof. Shortcodes come in two different flavors.Dedicated Shortcode: A three-digit code, like *243#, that is only used by one person to promote their product or service.Shared Shortcode: A shared shortcode is one that is utilized by numerous businesses or services. On our dedicated codes, each organization is given a channel, such as *243*25#.We will create a solid USSD that is simple to integrate so we can start offering your customers scalable options. With integration, we'll make sure your clients don't pay more to use the service."/>
                            </div>
                        </div>
                        {/* Start Slider Area  */}
                        {/* End Slider Area  */}
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default DigitalMarketing;
